export default __webpack_public_path__ + "locales/pt/HotkeysPanel.json?hash=9b5ccb14747d5638f5329c3a578d4b99";